import {EventEmitter} from 'events';


const CHANGE_EVENT = 'change';

var sliderModel = function(OptionsIn){

	EventEmitter.call(this, OptionsIn);

	this.percent = 50;
}

//Extend model
sliderModel.prototype = Object.create(EventEmitter.prototype);
//set constructor back to schoolsModel
sliderModel.prototype.constructor = sliderModel;

sliderModel.prototype.setSlider = function(val) {

	this.percent = parseInt(val);
	this.emit(CHANGE_EVENT);
}

sliderModel.prototype.getPercent = function() {

	return this.percent;
}

var radiusSliderState = new sliderModel;

export {radiusSliderState, sliderModel, CHANGE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/slider/radiusSlider.js